/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import { useEffect, useRef } from "react";
import { onRecovery } from "@/lib/recovery";

/**
 * A-2 (S711 review): run `handler` whenever the connection comes back (or the
 * customer presses Retry on the offline banner). The latest handler is always
 * the one called, so a screen can close over its current state without
 * re-subscribing on every render.
 */
export function useRecovery(handler: () => void): void {
  const latest = useRef(handler);
  latest.current = handler;
  useEffect(() => onRecovery(() => latest.current()), []);
}
